import { render, staticRenderFns } from "./ProtocolManagement.vue?vue&type=template&id=2e54c5e0&scoped=true&"
import script from "./ProtocolManagement.vue?vue&type=script&lang=js&"
export * from "./ProtocolManagement.vue?vue&type=script&lang=js&"
import style0 from "./ProtocolManagement.vue?vue&type=style&index=0&id=2e54c5e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e54c5e0",
  null
  
)

export default component.exports